import styled from 'styled-components'

import { ChartAnnotation } from '@/components/elements/ChartAnnotation'
import { Spacer } from '@/components/elements/Spacer'
import { Table } from '@/components/layouts/Ir/Mpocket/THDTable'


export const PLTable = () => {

  return (
    <>
      <Annotation>（百万円）</Annotation>
      <Spacer h={{ sp: 6, pc: 10 }} />
      <Table id="irp-highlight-table-pl" content='ir-financial-cfs' />
    </>
  )
}

export const BSTable = () => {
  return <Table id="irp-highlight-table-bs" content='ir-financial-cfs' />
}

export const CFTable = () => {
  return <Table id="irp-highlight-table-cf" content='ir-financial-cfs' />
}

const Annotation = styled(ChartAnnotation)`
  text-align: right;
`